/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressCity } from '../../models/address-city';

export interface FindCityAddress$Params {
  post_code?: string;
  town?: string;
}

export function findCityAddress(http: HttpClient, rootUrl: string, params?: FindCityAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AddressCity>>> {
  const rb = new RequestBuilder(rootUrl, findCityAddress.PATH, 'get');
  if (params) {
    rb.query('post_code', params.post_code, {});
    rb.query('town', params.town, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AddressCity>>;
    })
  );
}

findCityAddress.PATH = '/api/post_address/city';
